import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actions } from 'store/newDocumentStore';
import DocumentLoader from 'routes/Documents/containers/DocumentLoaderContainer';
import DocumentProvider from 'routes/Documents/containers/DocumentProvider';
import ViewStateContainer from 'routes/Documents/containers/ViewStateContainer';

import Status from '../components/Status';

const StatusContainer = ({ edit, create }) => (
  // MSNQ and FSMC docs supplied for aux purposes
  <DocumentLoader names={['status', 'predss', 'msnq', 'fsmc']}>
    <DocumentProvider>
      <ViewStateContainer>
        <Status onStartEdit={edit} onCreate={create} />
      </ViewStateContainer>
    </DocumentProvider>
  </DocumentLoader>
);

StatusContainer.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
};

export default connect(null, { edit: actions.createCommit, create: actions.createDocumentAndCommit })(StatusContainer);
